module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b58905e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Articles/Articles.vue
// module id = 331
// module chunks = 1